import b from 'b_';
import { Block as IconBlock, Info as IconInfo, Warning as IconWarning } from 'education-icons';
import React from 'react';

// TODO: EDUCATION-11293 ts fix
// @ts-ignore
import { IconQuestion, IconQuestionSmall } from '../../icon/icon';
import { HELP_TYPE } from '../help.constants';

import './help__icon.scss';

const IconHelp = ({ helpType: type }: { helpType?: HELP_TYPE }) => {
    switch (type) {
        case HELP_TYPE.QUESTION:
            return <IconQuestion mix="help__icon" />;
        case HELP_TYPE.QUESTION_SMALL:
            return <IconQuestionSmall mix="help__icon-question-small" />;
        case HELP_TYPE.INFO:
            return <IconInfo className={b('help', 'icon', { type })} />;
        case HELP_TYPE.ERROR:
            return <IconBlock className={b('help', 'icon', { type })} />;
        case HELP_TYPE.WARNING:
            return <IconWarning className={b('help', 'icon', { type })} />;
        default:
            return null;
    }
};

export default IconHelp;
